module.exports = __webpack_public_path__ + "static/4_2_recommendation_MT-8d883a5bc3367a8631245a1a8e173f04.svg";